import React from "react";
import GitchaLogo from "../../images/gitcha-logo-white.svg";
import UserTypeCard from "./UserTypeCard";
import { userTypes } from "../../constants/v2/common";

const UserTypeSelection = () => {
  return (
    <>
      <div className="outer-wrap position-relative mw-100 vh-100 first-wantad-wrap">
        <div className="user-type-header">
          <div className="overlay"></div>
          <div className="first-wantad-logo">
            <img src={GitchaLogo} alt="Logo" />
          </div>
        </div>

        <div className="container p-0">
          <div className="row">
            <div className="col-md-12 first-wantad-content user-type-content text-center">
              <h6>Woohoo!! 🎉 Welcome!</h6>
              <h2>What will you be using Gitcha for?</h2>
            </div>
          </div>
          <div className="row user-type-card-wrap">
            {userTypes.map((userType, index) => (
              <UserTypeCard
                key={index}
                icon={userType.icon}
                title={userType.title}
                heading={userType.heading}
                userTypeId={userType.userTypeId}
                description={userType.description}
                planSelection={userType.planSelection}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserTypeSelection;
